import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';

import {
  Download,
  DownloadContext,
  getSVGViewBox
} from '../assets';

@Component({
  selector: 'kyc-icon-download',
  template: Download.svg,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DownloadComponent implements SVG2TSDynamic, OnInit {
  public static UUID = 0;
  public baseUrl: string;
  @Input() public height: number | string = Download.height;
  @Input() public viewBox: string = getSVGViewBox(Download.viewBox);
  @Input() public width: number | string = Download.width;
  @Input()
  public set context(ctx: DownloadContext) {
    this.updateContext(ctx);
  }
  public get context() {
    return this._context;
  }

  private _context: DownloadContext = Download.contextDefaults;

  constructor(private _ref: ChangeDetectorRef) {}


  public getURLBase(value: string) {
    return `url('${this.getXlinkBase(value)}')`;
  }

  public getXlinkBase(value: string) {
    return `${this.baseUrl}${value}`;
  }

  public ngOnInit() {
    this.baseUrl = window.location.href.replace(window.location.hash, '');
    this.context.uuid = DownloadComponent.UUID++;
  }

  public updateContext(ctx: any) {
    this._context = Object.assign({}, this._context ? this._context : Download.contextDefaults, ctx);
    this._ref.markForCheck();
  }
}
